import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex flex-wrap categoryBlock pt-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Pro začátek vyberte kategorii, prosím", -1)
const _hoisted_9 = {
  key: 0,
  class: "small text-muted position-absolute p-2 bottom-0 end-0"
}
const _hoisted_10 = {
  key: 1,
  class: "flex-container non-scrollable"
}
const _hoisted_11 = { class: "my-3" }
const _hoisted_12 = { class: "cart-list scrollable" }
const _hoisted_13 = { class: "cart-bottom" }
const _hoisted_14 = { class: "fs-5" }
const _hoisted_15 = { class: "cart-list scrollable" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Poznámka pro obsluhu:", -1)
const _hoisted_18 = {
  class: "d-flex flex-column flex-wrap justify-content-between",
  style: {"gap":"10px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  class: "fw-bold",
  style: {"font-size":"60px"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "text-end"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = {
  key: 2,
  class: "unfinished-info-msg"
}

import btnPrimary from "@/components/btn-primary.vue";
import btnSecondary from "@/components/btn-secondary.vue";
import { useCartStore } from '@/store/CartStore';
import { categoriesTranslation } from '@/types/ProductCategory';
import { computed, ref } from '@vue/reactivity';
import OrderProductItem from '@/components/OrderProductItem.vue';
import CartProductItem from '@/components/CartProductItem.vue'
import Modal from '@/components/Modal.vue';
import IconScissors from '@/components/icon-scissors.vue';
import IconRouter from '@/components/icon-router.vue';
import IconReceipt from '@/components/icon-receipt.vue';
import { ModalResult } from '@/types/ModalResult';
import { PrintService } from '@/services/PrintService';
import { onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRoute } from 'vue-router';
import { goToCategory, currentCategory, isCategorySelected, cartPaneState, isBluetoothPrintMode } from '@/services/SubNavigation'
import { useShopHub } from "@/services/ShopHub";
import { OrderFinishModel } from "@/types/Order";
import { OrderService } from "@/services/OrderService";


export default /*#__PURE__*/_defineComponent({
  __name: 'Purchase',
  setup(__props) {

const innerWidth = ref(window.innerWidth)
const route = useRoute();
const cartStore = useCartStore();
cartStore.start();

function updateInnerWidth() {
    innerWidth.value = window.innerWidth;
}
onMounted(() => {
    window.addEventListener('resize', updateInnerWidth)
})
onBeforeUnmount(() => {
    cartStore.stop();
    window.removeEventListener('resize', updateInnerWidth)
})

const selectedCategoryName = computed(() => {
    const cur = currentCategory.value;
    return categoriesTranslation.find(c => c.val == cur)?.text;
});


const cancelOrderDialog = ref<InstanceType<typeof Modal>>();
function cancelOrderClicked() {
    cancelOrderDialog.value?.show();
}

function cancelOrder() {
    cartStore.resetOrder();
}

const confirmOrderDialog = ref<InstanceType<typeof Modal>>();
const printingDialog = ref<InstanceType<typeof Modal>>();
const orderId = ref(0);
const orderCompleted = ref(false);
const printService = new PrintService();

const isStaffMode = computed(() => route.path == '/staff-order')

async function printOrder() {
    await printService.printOrder(orderId.value);
    setTimeout(() => printingDialog.value?.close(), 5000);
}

const orderModalTitle = computed<string>(() => {
    if (orderCompleted.value) {
        return "Vyřízeno!"
    }
    else if (isStaffMode.value) {
        return isBluetoothPrintMode.value ? 'Vytisknout číslo?' : 'Předejte číslo objednávky';
    }
    else {
        return isBluetoothPrintMode.value ? 'Probíhá tisk...' : 'Počkejte na vyřízení';
    }
});

async function completeOrderClicked() {
    const res = await confirmOrderDialog.value?.showAsync();
    if (res == ModalResult.Button2) {
        orderId.value = await cartStore.placeOrder();
        printingDialog.value?.show();
        if (!isStaffMode.value) {
            if (isBluetoothPrintMode.value) {
                // Print the number for the electronic system customers
                await printOrder();
            }
            else {
                await waitToCompleteOrder();
            }
        }
    }
}

const shopHub = useShopHub();
async function waitToCompleteOrder(): Promise<void> {
    return new Promise((res) => {
        function orderFinished(data: OrderFinishModel) {
            if (data.id == orderId.value) {
                orderCompleted.value = true;
                setTimeout(() => {
                    nextTick(() => {
                        alert(`Vaše objednávka číslo ${orderId.value} byla dokončena.`);
                        printingDialog.value?.close();
                        orderCompleted.value = false;
                        res();
                    });
                }, 500);
            }
            shopHub.OrderFinished.off(orderFinished);
            shopHub.Established.off(reestablished);
            localStorage.removeItem("lastUnfinishedOrderId");
            window.onbeforeunload = () => { };
        }
        async function reestablished() {
            const os = new OrderService();
            const orderInfo = await os.getOrderDisplayDetail(orderId.value);
            if (orderInfo.isFinished) {
                orderFinished(orderInfo);
            }
        }
        shopHub.OrderFinished.on(orderFinished);
        shopHub.Established.on(reestablished);
        localStorage.setItem("lastUnfinishedOrderId", orderId.value.toString());
        window.onbeforeunload = function (e) {
            return "";//Notify the user he really shouldnt leave the page at this state (he is waiting for order finish)
        }
    })
}

const possibleUnfinishedOrderId = ref(0);
const lastUnfinishedOrderId = localStorage.getItem("lastUnfinishedOrderId");
if (lastUnfinishedOrderId != null) {
    const theId = Number(lastUnfinishedOrderId);
    nextTick(async () => {
        const os = new OrderService();
        const orderInfo = await os.getOrderDisplayDetail(theId);
        if (!orderInfo.isFinished) {
            possibleUnfinishedOrderId.value = theId;
        } else {
            localStorage.removeItem("lastUnfinishedOrderId");
        }
    });
}

function noteInputKeyUp(event: KeyboardEvent) {
    const area = event.target as HTMLInputElement;
    area.style.minHeight = area.scrollHeight + "px";
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["purchase-columns non-scrollable", _unref(possibleUnfinishedOrderId) != 0 ? 'pb-4' : '']),
    style: _normalizeStyle({
        display: _unref(cartPaneState) == 1 && _unref(innerWidth) >= 600 ? 'grid' : 'flex'
    })
  }, [
    (_unref(cartPaneState) != 2)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_unref(isCategorySelected))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoriesTranslation), (category) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "card interactive",
                      key: category.val,
                      onClick: ($event: any) => (_unref(goToCategory)(category.val))
                    }, [
                      _createElementVNode("img", {
                        class: "card-img-top p-2",
                        src: category.image
                      }, null, 8, _hoisted_4),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("h5", _hoisted_6, _toDisplayString(category.text), 1)
                      ])
                    ], 8, _hoisted_3))
                  }), 128))
                ]),
                _hoisted_7,
                _hoisted_8,
                (_unref(isBluetoothPrintMode))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Mód tiskového terminálu"))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, "Kategorie: " + _toDisplayString(_unref(selectedCategoryName)), 1),
                _createElementVNode("div", {
                  class: _normalizeClass('purchase-product-grid scrollable' + (_unref(cartPaneState) == 1 ? ' pe-2' : ''))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).filteredProducts, (product) => {
                    return (_openBlock(), _createBlock(OrderProductItem, {
                      key: product.id,
                      product: product
                    }, null, 8, ["product"]))
                  }), 128))
                ], 2)
              ]))
        ], 64))
      : _createCommentVNode("", true),
    ((_unref(cartStore).newOrderProcessBegun || _unref(cartPaneState) == 2) && _unref(cartPaneState) != 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass('cart-container flex-container non-scrollable pt-2' + (_unref(cartPaneState) != 2 ? ' ps-2 border-start' : '')),
          style: _normalizeStyle({
                'grid-column': _unref(cartPaneState) == 2 ? 1 : 2
            })
        }, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).cartContent, (product) => {
              return (_openBlock(), _createBlock(CartProductItem, {
                key: product.id,
                product: product
              }, null, 8, ["product"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(cartStore).cartTotal.toFixed(2)) + " Kč", 1),
              _createTextVNode(" celkem")
            ]),
            _createVNode(btnSecondary, {
              onClick: cancelOrderClicked,
              disabled: !_unref(cartStore).canOrder
            }, {
              default: _withCtx(() => [
                _createTextVNode("Vyprázdnit košík")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(btnPrimary, {
              onClick: completeOrderClicked,
              disabled: !_unref(cartStore).canOrder
            }, {
              default: _withCtx(() => [
                _createTextVNode("Dokončit objednávku")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 6))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      ref_key: "cancelOrderDialog",
      ref: cancelOrderDialog,
      "click-closes": true,
      title: "Zrušit objednávku",
      message: "Opravdu chcete zrušit tuto objednávku ? Všechny položky košíku budou odstraněny",
      button1msg: "Vrátit se zpět",
      button2msg: "Zrušit objednávku",
      onClicked2: cancelOrder,
      button1type: "secondary",
      button2type: "danger"
    }, null, 512),
    _createVNode(Modal, {
      ref_key: "confirmOrderDialog",
      ref: confirmOrderDialog,
      "click-closes": true,
      title: "Dokončit objednávku",
      button1msg: "Vrátit se zpět",
      button1type: "secondary",
      button2type: "primary",
      button2msg: "Dokončit objednávku"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).cartContent, (product) => {
            return (_openBlock(), _createBlock(CartProductItem, {
              key: product.id,
              product: product
            }, null, 8, ["product"]))
          }), 128)),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("textarea", {
              id: "orderNoteInput",
              class: "form-control",
              rows: "2",
              placeholder: "Přejete si přidat kečup, hořčici, či jinou poznámku?",
              onKeyup: noteInputKeyUp,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(cartStore).orderNote) = $event))
            }, null, 544), [
              [_vModelText, _unref(cartStore).orderNote]
            ])
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      ref_key: "printingDialog",
      ref: printingDialog,
      "click-closes": false,
      "show-close-button": _unref(isStaffMode),
      button1type: _unref(isStaffMode) && _unref(isBluetoothPrintMode) ? 'primary' : undefined,
      button1msg: _unref(isStaffMode) && _unref(isBluetoothPrintMode) ? 'Vytisknout' : undefined,
      onClicked1: printOrder,
      title: _unref(orderModalTitle)
    }, {
      icon: _withCtx(() => [
        _createVNode(IconReceipt, { width: "36" })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", null, [
            _createTextVNode(" Objednávka číslo: "),
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(orderId)), 1)
          ]),
          (_unref(orderCompleted))
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Dokončena "))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(isBluetoothPrintMode))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                      _createTextVNode(" Odstřihněte prosím papírek "),
                      _createVNode(IconScissors, {
                        width: "60",
                        class: "d-block ms-auto"
                      }),
                      _createTextVNode(" Zatím se to musí stříhat ručně ;) ")
                    ]))
                  : (!_unref(isStaffMode))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                        _createTextVNode(" Toto okno bude zavřeno, jakmile bude vaše objednávka dokončena "),
                        _createElementVNode("small", _hoisted_24, [
                          _createTextVNode(" pokud ovšem budete připojeni k internetu "),
                          _createVNode(IconRouter)
                        ])
                      ]))
                    : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      _: 1
    }, 8, ["show-close-button", "button1type", "button1msg", "title"]),
    (_unref(possibleUnfinishedOrderId) != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createTextVNode(" Číslo poslední objednávky: " + _toDisplayString(_unref(possibleUnfinishedOrderId)) + " ", 1),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (possibleUnfinishedOrderId.value = 0))
          })
        ]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})